"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getOptionsForValidLanguages = exports.getLanguageOptions = void 0;

var _I18n = _interopRequireDefault(require("I18n"));

var _sortOptions = _interopRequireDefault(require("./sortOptions"));

var allLanguageOptions = [];

var getLanguagesByCode = function getLanguagesByCode() {
  // Should return lowercase language codes and their translations
  return _I18n.default.text('SharedI18nStrings.languageNames');
};

var getLanguageOptions = function getLanguageOptions(_ref) {
  var optionsFilter = _ref.optionsFilter;

  if (!optionsFilter && allLanguageOptions.length) {
    return allLanguageOptions;
  } else if (optionsFilter && allLanguageOptions.length) {
    return allLanguageOptions.filter(optionsFilter);
  }

  var languagesByCode = getLanguagesByCode();
  allLanguageOptions = Object.keys(languagesByCode).map(function (key) {
    return {
      text: languagesByCode[key],
      value: key
    };
  }).sort(_sortOptions.default);

  if (optionsFilter) {
    return allLanguageOptions.filter(optionsFilter);
  }

  return allLanguageOptions;
};

exports.getLanguageOptions = getLanguageOptions;

var getOptionsForValidLanguages = function getOptionsForValidLanguages(_ref2) {
  var validLanguages = _ref2.validLanguages,
      optionsFilter = _ref2.optionsFilter;
  var options = [];
  var languagesByCode = getLanguagesByCode();
  validLanguages.forEach(function (lang) {
    if (languagesByCode[lang]) {
      options.push({
        text: languagesByCode[lang],
        value: lang
      });
    }
  });

  if (optionsFilter) {
    options = options.filter(optionsFilter);
  }

  return options.sort(_sortOptions.default);
};

exports.getOptionsForValidLanguages = getOptionsForValidLanguages;